import Connection from '../signalr/connection';

export let getScraperDetails = (ossId) => {
    return Connection.then(c => c.invoke("GetScraperDetail", ossId));
};

export let getStateDetails = (stateAbbreviation) => {
    return Connection.then(c => c.invoke("GetStateDetail", stateAbbreviation));
};

export let getCaseAndChargeCounts = (ossId) => {
    return Connection.then(c => c.invoke("GetCaseAndChargeCounts", ossId));
};

export let getSourceCaseTypeInfo = (ossId) => {
    return Connection.then(c => c.invoke("GetSourceCaseTypeInfos", ossId));
};

export let getSourceCaseTypeInfosAggregateBySource = (ossId) => {
    return Connection.then(c => c.invoke("GetSourceCaseTypeInfosAggregateBySource", ossId));
};

export let getSourceSymptomsInfo = (ossId) => {
    return Connection.then(c => c.invoke("GetSourceSymptomsInfo", ossId));
};

export let addMonitoringOrders = (orders) => {
    return Connection.then(c => c.invoke("AddMonitoringOrders", {
        Orders: orders
    }));
};

export let forceUpdateMonitoringOrder = (personId) => {
    return Connection.then(c => c.invoke("ForceUpdateMonitoringOrder", {
        PersonId: personId
    }));
};